import { Grid, makeStyles, CircularProgress } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    iconBoutton: {
        position: 'absolute',
        top: '5px',
        right: '5px'
    },

}));